import { render, staticRenderFns } from "./MarketApproveAreaInterest.vue?vue&type=template&id=86c8a576"
import script from "./MarketApproveAreaInterest.vue?vue&type=script&lang=js"
export * from "./MarketApproveAreaInterest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports